import { defineSlotRecipe } from '@chakra-ui/react';

export const drawerSlotRecipe = defineSlotRecipe({
  slots: [
    'root',
    'trigger',
    'backdrop',
    'positioner',
    'content',
    'header',
    'body',
    'footer',
    'closeTrigger',
  ],
  base: {
    root: {
      display: 'flex',
      flexDirection: 'column',
    },
    body: {
      px: '6',
      py: '4',
    },
    header: {
      px: '6',
      py: '4',
      fontSize: 'lg',
      fontWeight: 'bold',
    },
    content: {
      borderTopRadius: { base: '2xl', md: 'none' },
    },
  },
});
